export default __webpack_public_path__ + "static/media/amparo-material-3.e6eaac3e.webp";